import React from 'react'
import { string, bool } from 'prop-types'
import intl from 'react-intl-universal'
import triggerEvent from 'utils/dataLayer'

import Avatar from 'components/atoms/Avatar'
import Typography from 'components/atoms/Typography'
import LikeButton from 'components/molecules/LikeButton'
import AdmissionRegistrationButton from 'components/molecules/AdmissionRegistrationButton'
import AdmissionDownloadBrochure from 'components/molecules/AdmissionDownloadBrochure'
import ActionTypeProp from 'utils/prop_types/ActionTypeProp'

const StickyBottomSchool = ({
  logo,
  name,
  slug,
  paid,
  registrationUrl,
  brochureUrl,
  likeStatus,
  likeTarget,
  type,
}) => (
  <div className="sticky-bottom-school swing-in-bottom">
    <div className="sticky-bottom-school__profile">
      {
        logo &&
        <Avatar
          className="sticky-bottom-school__logo"
          size={56}
          bordered
        >
          <img src={logo} alt={name}/>
        </Avatar>
      }
      <Typography className="sticky-bottom-school__name" component="h6" variant="body">
        { name }
      </Typography>
    </div>
    <div className="sticky-bottom-school__action">
      <LikeButton
        className="sticky-bottom-school__like-btn"
        active={likeStatus}
        kind="schools"
        targetId={likeTarget}
        type={type}
        complete
        forDetailPage
        useNewIcon
        handleClick={() => triggerEvent('campus_favourite', {
          campus_name: name,
          favorite_button_location: 'sticky',
          page_location: `/directory/${slug}`,
        })}
      >
        {
          !!(!registrationUrl && (!brochureUrl || !paid)) &&
          <span>
            {likeStatus ? intl.get('common.remove_from_favorite') : intl.get('common.add_to_favorite')}
          </span>
        }
      </LikeButton>
      {
        registrationUrl &&
        <AdmissionRegistrationButton type={type} isRound/>
      }
      {
        (!registrationUrl && brochureUrl) &&
        <AdmissionDownloadBrochure isRound/>
      }
    </div>
    <style jsx>
      {`
        .sticky-bottom-school {
          display: flex;
          justify-content: space-between;
          &__profile {
            display: none;
            @media screen and (min-width: 768px) {
              display: flex;
              align-items: center;
            }
          }
          &__action {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            @media screen and (min-width: 768px) {
              justify-content: flex-end;
              width: unset;
            }
          }
          :global(&__logo) {
            padding: 6px !important
          }
          :global(&__name) {
            padding: 16px;
            font-weight: bold !important;
            color: #0c2846;
          }
          :global(&__button) {
            font-size: 14px;
            font-weight: bold;
            box-shadow: 0 2px 4px 0 rgba(107, 143, 188, 0.85);
            padding: 14px 28px;
            border: none;
            margin: 0 8px;
            flex-grow: 1;
            @media screen and (min-width: 768px) {
              flex-grow: unset;
            }
          }
          :global(&__like-btn) {
            padding: 6px !important;
            @media screen and (max-width: 767px) {
              display: none;
            }
          }
          :global(svg) {
            width: 32px;
            height: 32px;
          }
        }
        @media screen and (max-width: 767px) {
          .swing-in-bottom {
            animation: swing-in-bottom 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
          }
          @-webkit-keyframes swing-in-bottom {
            0% {
              transform: translateY(1000px);
              opacity: 0;
            }
            100% {
              transform: rotateY(0);
              opacity: 1;
            }
          }
          @keyframes swing-in-bottom {
            0% {
              transform: translateY(1000px);
              opacity: 0;
            }
            100% {
              transform: translateY(0);
              opacity: 1;
            }
          }
        }
      `}
    </style>
  </div>
)

StickyBottomSchool.propTypes = {
  logo: string,
  name: string,
  slug: string,
  registrationUrl: string,
  brochureUrl: string,
  likeStatus: bool,
  likeTarget: string,
  paid: bool,
  type: ActionTypeProp,
}

export default StickyBottomSchool
